export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true
  },
  actionTypes: {
    foul: ['FOUL']
  },
  modules: {
    info: [
      'timer',
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      score: ingameData => ingameData.score,
      total: ingameData => ingameData.fouls
    },
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    fouls: {
      home: 0,
      away: 0
    },
    getOvertimePeriodName: 'OT'
  }
}
